import resolveGenericStrategy from '../generic/resolve.js';

export default async function resolveOpenAPI2Strategy(options) {
  return resolveGenericStrategy(options);
}
